import { tv } from 'tailwind-variants';

const headingStyles = tv({
    slots: {
        base: `
    iris:font-(family-name:--base-type-font-heading)
    iris:font-(--sem-type-weight-heading)!
    iris:tracking-(--sem-type-tracking-heading)
    iris:text-(--comp-color-content-type-heading)
  `,
        leading: "iris:leading-(--sem-type-leading-heading)",
    },
    variants: {
        size: {
            md: `
        iris:text-(length:--sem-type-size-heading-md-mobile)
        iris:lg:text-(length:--sem-type-size-heading-md-desktop)
      `,
            lg: `
        iris:text-(length:--sem-type-size-heading-lg-mobile)
        iris:lg:text-(length:--sem-type-size-heading-lg-desktop)
      `,
            xl: `
        iris:text-(length:--sem-type-size-heading-xl-mobile)
        iris:lg:text-(length:--sem-type-size-heading-xl-desktop)
      `,
            xxl: `
        iris:text-(length:--sem-type-size-heading-xxl-mobile)
        iris:lg:text-(length:--sem-type-size-heading-xxl-desktop)
      `,
        },
        inverse: {
            true: "iris:text-(--comp-color-content-type-heading-inverse)",
        },
    },
    // Default variants for the headingStyles
    defaultVariants: {
        size: "md",
        inverse: false,
    },
});

export { headingStyles as default };
